import {
  ARCHIVED_STATE,
  COMPLETED_STATE,
  INITIAL_INFO_LOADED_STATE,
  INITIAL_STATE,
  PATIENT_INITIATED_STATE,
  PHARMACY_INITIATED_STATE,
  WAITING_FOR_PATIENT_STATE,
  WAITING_FOR_PHARMACY_STATE,
} from '@libs/shared/domain/patient-assistance/business-flow/process-flow/customer-support/shared-business-flow-process-flow-customer-support-process-state.type';

export const SHARED_BUSINESS_FLOW_PROCESS_FLOW_CUSTOMER_SUPPORT_PROCESS_STATE_NAME_MAP = {
  [INITIAL_STATE]: 'Initial',
  [INITIAL_INFO_LOADED_STATE]: 'Initial info loaded',
  [PHARMACY_INITIATED_STATE]: 'Pharmacy New',
  [PATIENT_INITIATED_STATE]: 'Patient New',
  [WAITING_FOR_PHARMACY_STATE]: 'Pending Pharmacy',
  [WAITING_FOR_PATIENT_STATE]: 'Pending Patient',
  [COMPLETED_STATE]: 'Finished',
  [ARCHIVED_STATE]: 'Archived',
};
